// extracted by mini-css-extract-plugin
export var currencyInput = "_jb-1";
export var currencySymbol = "_jb-0";